






















import { mapGetters } from 'vuex';
import Item from '@/types/Item';
import Product from '@/types/Product';
import ProductionPeriod from '@/types/ProductionPeriod';

export default {
	name: 'ItemCard',

	props: {
		itemId: String
	},

	computed: {
		...mapGetters(['itemById', 'getCurrencySymbol', 'getLanguage'])
	},

	methods: {
        list: (productionPeriods: ProductionPeriod[]): string => {
			return Product.listProductionPeriod(productionPeriods);
		},

        extraDescriptionText(item: Item): string {
            const text = new Array<string>();
            if (item.originalSticker) {
                text.push('Etikett');
            }
            if (item.perfectCondition) {
                text.push('Perfekt Skick');
            }
            return text.join(', ');
        }
    }
};
